import { useState, useEffect, useCallback } from 'react';

/**
 * Hook to manage language notification on first visit
 * Shows a notification to inform users they can change the language
 */
export const useLanguageNotification = () => {
  const STORAGE_KEY = 'language_notification_dismissed';
  const [showNotification, setShowNotification] = useState(false);

  useEffect((): (() => void) | void => {
    // Check if notification has been dismissed before
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      // Show notification after a brief delay for better UX
      const timer = setTimeout(() => {
        setShowNotification(true);
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, []);

  const dismissNotification = useCallback(() => {
    setShowNotification(false);
    localStorage.setItem(STORAGE_KEY, 'true');
  }, []);

  return {
    showNotification,
    dismissNotification,
  };
};
